var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeco2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 652,
    height: 653,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    overflow: "hidden",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-29 -38)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.5087 309.619C64.8749 132.897 233.344 15.1021 409.794 46.5165 586.244 77.931 703.858 246.659 672.492 423.381 648.811 556.807 544.951 661.511 411.888 686.104Z",
    stroke: "#000000",
    strokeWidth: 4.58333,
    strokeMiterlimit: 8,
    fill: "#FFFFFF",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.5 372.106C125.441 246.462 227.249 144.559 352.893 144.5 478.538 144.441 580.441 246.248 580.5 371.893 580.559 497.538 478.752 599.441 353.107 599.5 353.071 599.5 353.036 599.5 353 599.5Z",
    stroke: "#000000",
    strokeWidth: 4.58333,
    strokeMiterlimit: 8,
    fill: "#FFD600",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M473.5 359.5C473.5 431.297 415.297 489.5 343.5 489.5",
    stroke: "#000000",
    strokeWidth: 1.14583,
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M498.483 357.75C482.098 365.052 462.896 357.69 455.594 341.305",
    stroke: "#000000",
    strokeWidth: 1.14583,
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.7627 312.338C211.035 281.507 378.887 399.632 409.67 576.177 415.938 612.122 416.107 648.869 410.171 684.871Z",
    stroke: "#000000",
    strokeWidth: 4.58333,
    strokeMiterlimit: 8,
    fill: "#FFFFFF",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.805 280.966C349.341 248.717 347.466 221.901 351.616 221.069 355.767 220.237 364.371 245.705 370.835 277.953 377.299 310.201 379.175 337.018 375.024 337.85 370.874 338.682 362.269 313.214 355.805 280.966Z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.482 294.46C282.018 262.212 280.143 235.395 284.293 234.563 288.443 233.731 297.048 259.199 303.512 291.447 309.976 323.696 311.851 350.512 307.701 351.344 303.55 352.176 294.946 326.708 288.482 294.46Z",
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeco2);
export default __webpack_public_path__ + "static/media/deco2.24c6360c332556da0c3656f3c03811f7.svg";
export { ForwardRef as ReactComponent };